// Resource search — jQuery + Handlebars replacement for the old AngularJS resourceController.
// Behaviour mirrors the original controller 1:1: it reads the dropdown collection and the
// current query string, POSTs the full URL to /api/SiteApi/ResourceSearch, and renders the
// results, filter checkboxes and pagination client-side.
(function () {
    "use strict";

    // Maps a filter type to its query-string key (server-side names) and its rendered
    // checkbox-list container. Checkbox element ids follow "checkbox_<type>_<value>".
    var FILTERS = [
        { type: "audience", listProp: "audienceList", urlKey: "audience", container: "#cbl-audience" },
        { type: "yearLevel", listProp: "yearLevelList", urlKey: "year", container: "#cbl-yearLevel" },
        { type: "format", listProp: "formatList", urlKey: "format", container: "#cbl-format" },
        { type: "capability", listProp: "capabilityList", urlKey: "capability", container: "#cbl-capability" },
        { type: "learningArea", listProp: "learningAreaList", urlKey: "learningarea", container: "#cbl-learningArea" },
        { type: "framework", listProp: "frameworkList", urlKey: "framework", container: "#cbl-framework" }
    ];

    var itemsPerPage = 12;
    var baseUrl = "";        // canonical node url — used for the pushState history url
    var cardBaseUrl = "";    // request path — prefixed onto each result card's href
    var defaultAudience = "";
    var defaultYearLevel = "";
    var currentPage = 1;

    // selected[type] = array of selected filter values
    var selected = {};
    FILTERS.forEach(function (f) { selected[f.type] = []; });

    var $container;
    var resultsTemplate;
    var filterTemplate;

    function filterByType(type) {
        for (var i = 0; i < FILTERS.length; i++) {
            if (FILTERS[i].type === type) return FILTERS[i];
        }
        return null;
    }

    // Strip template/HTML syntax so characters like {{ }} can never reach the URL or the API.
    function sanitize(value) {
        return (value || "").replace(/[{}<>\[\]]/g, "");
    }

    function getParameterByName(name) {
        var urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    // --- rendering -------------------------------------------------------

    function renderFilterCheckboxes(data) {
        FILTERS.forEach(function (f) {
            var items = (data && data[f.listProp]) ? data[f.listProp] : [];
            $(f.container).html(filterTemplate({ items: items, type: f.type }));
        });
    }

    function renderResults(response) {
        var resources = (response && response.resources) ? response.resources : [];
        var totalItems = (response && response.totalItems) ? response.totalItems : 0;

        $("#resources-info span").text(totalItems + " resources");
        $("#resource-results-container").html(resultsTemplate({ resources: resources, cardBaseUrl: cardBaseUrl }));
        renderPaging(response);
    }

    function renderPaging(response) {
        var $paging = $("#resource-paging-container");

        if (!response || !response.totalPages || response.totalPages <= 1) {
            $paging.empty();
            return;
        }

        var current = response.currentPage;
        var total = response.totalPages;
        var pages = response.pages || [];
        var html = '<ul class="paging">';

        // Previous
        if (current > 1) {
            html += '<li class="paging__previous"><a href="#" data-page="' + (current - 1) + '">Previous</a></li>';
        } else {
            html += '<li class="paging__previous disabled"><a>Previous</a></li>';
        }

        // Page numbers
        pages.forEach(function (x) {
            var cls = (x === current) ? "paging__page current" : "paging__page";
            html += '<li class="' + cls + '"><a href="#" data-page="' + x + '">' + x + '</a></li>';
        });

        // Next
        if (current < total) {
            html += '<li class="paging__next"><a href="#" data-page="' + (current + 1) + '">Next</a></li>';
        } else {
            html += '<li class="paging__next disabled"><a>Next</a></li>';
        }

        html += "</ul>";
        $paging.html(html);
    }

    // --- url + selection state ------------------------------------------

    function updateUrl() {
        var url = baseUrl + "?currentPage=" + currentPage;

        // URL-encode every user-derived value so characters like {{ }} become %7B and can
        // never be reflected back as live template syntax.
        var keywords = $("#resource-search-box").val();
        if (keywords) {
            url += "&keywords=" + encodeURIComponent(keywords);
        }

        FILTERS.forEach(function (f) {
            if (selected[f.type] && selected[f.type].length > 0) {
                url += "&" + f.urlKey + "=" + encodeURIComponent(selected[f.type].join("|"));
            }
        });

        window.history.pushState("", "", url);
    }

    function setSelectedItems() {
        // Strip template/HTML syntax from the URL-derived keyword before binding it into the box.
        $("#resource-search-box").val(sanitize(getParameterByName("keywords")));

        FILTERS.forEach(function (f) {
            var qs = getParameterByName(f.urlKey);
            selected[f.type] = qs ? qs.split("|") : [];
        });

        // Reflect the selected values onto the rendered checkboxes.
        $(".filter-cb").prop("checked", false);
        FILTERS.forEach(function (f) {
            selected[f.type].forEach(function (value) {
                $("#checkbox_" + f.type + "_" + value).prop("checked", true);
            });
        });
    }

    // --- search ----------------------------------------------------------

    function search(page, updateUrlFlag) {
        // Two-way-binding replacement: clean the box and write the cleaned value back.
        $("#resource-search-box").val(sanitize($("#resource-search-box").val()));

        currentPage = page;

        if (updateUrlFlag) {
            updateUrl();
        } else {
            setSelectedItems();
        }

        $.ajax({
            url: "/api/SiteApi/ResourceSearch",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({
                fullUrlQueryString: window.location.href,
                itemsPerPage: itemsPerPage
            }),
            success: function (response) {
                renderResults(response);
            },
            error: function (error) {
                console.log("ResourceSearch error:", error);
            }
        });
    }

    function filterChecked(type, value) {
        var list = selected[type];
        if (!list) return;

        var idx = list.indexOf(value);
        if (idx !== -1) {
            list.splice(idx, 1);
        } else {
            list.push(value);
        }

        search(1, true);
    }

    function reset() {
        $("#resource-search-box").val("");
        FILTERS.forEach(function (f) { selected[f.type] = []; });
        search(1, true);
        $(".filter-cb").prop("checked", false);
    }

    function setDefaults() {
        if (window.location.search.length === 0) {
            if (defaultAudience) {
                selected.audience.push(defaultAudience);
            }
            if (defaultYearLevel) {
                selected.yearLevel.push(defaultYearLevel);
            }
            updateUrl();
        }

        search(1, false);
    }

    function getDropdownCollection() {
        $.ajax({
            url: "/api/SiteApi/GetDropdownCollection",
            type: "GET",
            success: function (data) {
                renderFilterCheckboxes(data);
                // Checkboxes now exist in the DOM, so defaults/URL selection can be applied.
                setDefaults();
            },
            error: function (error) {
                console.log("GetDropdownCollection error:", error);
            }
        });
    }

    function bindEvents() {
        // Search button + Enter key
        $("#resource-btnSearch").on("click", function (e) {
            e.preventDefault();
            search(1, true);
        });
        $("#resource-search-box").on("keypress", function (e) {
            if (e.which === 13) {
                e.preventDefault();
                search(1, true);
            }
        });

        // Filter checkboxes (delegated — rendered after load)
        $container.on("click", ".filter-cb", function () {
            filterChecked($(this).data("filter-type"), String($(this).data("filter-value")));
        });

        // Reset
        $container.on("click", ".reset-btn", function (e) {
            e.preventDefault();
            reset();
        });

        // Pagination (delegated — re-rendered on every search)
        $container.on("click", "#resource-paging-container a[data-page]", function (e) {
            e.preventDefault();
            search(parseInt($(this).data("page"), 10), true);
        });
    }

    $(function () {
        $container = $("#resourceSearch");
        if (!$container.length) return;

        baseUrl = $container.data("base-url") || "";
        cardBaseUrl = $container.data("card-base-url") || "";
        defaultAudience = $container.data("default-audience") || "";
        defaultYearLevel = $container.data("default-year-level") || "";

        resultsTemplate = Handlebars.compile($("#resourceResultsTemplate").html());
        filterTemplate = Handlebars.compile($("#filterCheckboxTemplate").html());

        bindEvents();
        getDropdownCollection();
    });
})();
